<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M15.41 16.58L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.42z"/>
    </svg>
</template>

<script>
export default {
    name: 'ChevronLeftIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
